import { JDSSidePanelInternalProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSSidePanelInternalProps>
  ): React.FC<JDSSidePanelInternalProps> =>
  (props: JDSSidePanelInternalProps) => {
    return <Component {...props} />;
  };
